import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { INotification } from './notification.interface';

@Injectable({
  providedIn: 'root' // Disponível Globalmente
})
export class NotificationService {
  private notificationSubject = new BehaviorSubject<INotification | null>(null);
  public notification$ = this.notificationSubject.asObservable();

  showNotification(notification: INotification): void {
    notification.message = this.formatTextWithTags(notification.message);
    this.notificationSubject.next({ ...notification, isVisible: true });

    if (notification.autoClose) {
      setTimeout(() => this.closeNotification(), notification.autoCloseDuration);
    }
  }

  closeNotification(): void {
    const currentNotification = this.notificationSubject.value;
    if (currentNotification) {
      this.notificationSubject.next({ ...currentNotification, isVisible: false });
    }
  }

  generateUniqueId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  }

  formatTextWithTags(text: string): string {
    return text.replace(/\[/g, '<strong>').replace(/\]/g, '</strong>');
  }
}
